import {
  Box,
  Avatar,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Typography,
  withStyles,
  Divider,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import DataService from "../../../../../Service";
import EditIcon from "@material-ui/icons/Edit";
import CustomInput from "../../../../../Components/CustomInput";
import { ObjectToFormdata } from "../../../../../Common/Utils/common_utils";

function TermCondition(props) {
  const [pageData, setPageData] = useState([]);
  const [currentId, setCurrentId] = useState("");
  const [currentContentId, setCurrentContentId] = useState("");
  const [open, setOpen] = useState(false);
  const [userData, setUserData] = useState({
    field_value: "",
    field_name: "",
  });

  useEffect(() => getCompetency(), [props.organisationId]);

  const getCompetency = () => {
    // setLoading(true)
    const params = {
      organisation_id: props.organisationId,
    };

    DataService.getDirectData("terms_and_policies", params)
      .then((res) => {
        console.log(`res`, res);
        // setLoading(false)
        pageData.length = 0;
        // setTableData(tableData.concat(res.competencies))
        setPageData(pageData.concat(res.terms_and_policies_sections));
      })
      .catch((err) => {
        // setLoading(false);
      });
  };

  const hoverOnContain = (e, obj) => {
    e.stopPropagation();
    setCurrentId(obj.id);
    setCurrentContentId(obj.terms_and_policies_section_id);
    setUserData({
      ...userData,
      field_name: obj.field_name,
      field_value: obj.field_value,
    });
  };
  const handleClose = () => {
    setOpen(false);
  };

  const setInputState = (inputStateValue, inputId) => {
    setUserData({ ...userData, [inputId]: inputStateValue });
  };

  const editCompetency = (event) => {
    // setLoading(true)
    var flag = false;
    if (userData.field_name != "" && userData.field_value != "") {
      flag = true;
    } else {
      alert("Please enter both title and description value");
    }
    if (flag) {
      var postData = { id: currentId, ...userData };

      DataService.updateData(
        ObjectToFormdata({ ...postData }),
        currentId,
        "terms_and_policies_fields"
      )
        .then((res) => {
          console.log(`res`, res);
          handleClose();
          getCompetency();
        })
        .catch((err) => {
          // setLoading(false);
        });
    }
  };

  return (
    <Box p={3}>
      <Grid container direction="row" spacing={1}>
        <Grid item xs="12">
          <Grid container direction="row" spacing={1}>
            <Grid item xs="12">
              <Typography variant="h1" color="secondary">
                <Box mb={3} fontWeight="fontWeightBold">
                  Terms and Policies
                </Box>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs="12">
          {pageData.length > 0 &&
            pageData.map((option) => {
              return (
                <Grid container direction="row" spacing={1}>
                  <Grid item xs="12">
                    <Divider />
                    <Typography variant="subtitle1" color="secondary">
                      <Box
                        pt={3}
                        fontWeight="fontWeightBold"
                        style={{ textTransform: "none" }}
                      >
                        {option.section_name}
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs="12">
                    <Box py={3} px={4}>
                      {option.terms_and_policies_fields.map((options) => {
                        return (
                          <Box
                            p={2}
                            style={{
                              backgroundColor:
                                options.id == currentId ? "#ddd" : "",
                            }}
                            onMouseEnter={(e) => {
                              hoverOnContain(e, options);
                            }}
                          >
                            <Grid
                              container
                              direction="row"
                              spacing={1}
                              alignItems="center"
                            >
                              <Grid item xs="11">
                                <Typography variant="h2">
                                  <Box pb={3} fontWeight="fontWeightBold">
                                    {options.field_name}
                                  </Box>
                                </Typography>
                                <Typography variant="h2">
                                  <Box>{options.field_value}</Box>
                                </Typography>
                              </Grid>
                              <Grid item xs="1">
                                <Box
                                  textAlign="right"
                                  style={{
                                    display:
                                      options.id == currentId
                                        ? "block"
                                        : "none",
                                  }}
                                >
                                  <EditIcon
                                    onClick={() => {
                                      setOpen(true);
                                    }}
                                  />
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                        );
                      })}
                    </Box>
                  </Grid>
                </Grid>
              );
            })}
        </Grid>
      </Grid>
      <Box>
        <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullWidth="100%"
          style={{ padding: 24 }}
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            <Box>
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                Edit terms & policies
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <Box px={3}>
              <Grid container direction="row" alignItems="center">
                <Grid item xs={3}>
                  <Typography variant="h2">
                    <Box>Title </Box>
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <CustomInput
                    autofocus
                    id="field_name"
                    variant="outlined"
                    placeholder="Enter filed name"
                    parentcall={setInputState}
                    value={userData.field_name}
                  />
                </Grid>
              </Grid>
            </Box>
            <Box px={3} mt={2}>
              <Grid container direction="row" alignItems="center">
                <Grid item xs={3}>
                  <Typography variant="h2">
                    <Box> Description</Box>
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <CustomInput
                    id="field_value"
                    variant="outlined"
                    placeholder="Enter filed value"
                    parentcall={setInputState}
                    value={userData.field_value}
                  />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Box px={3} py={2}>
              <Button
                disableElevation
                variant="contained"
                onClick={handleClose}
                style={{ textTransform: "none" }}
              >
                Cancel
              </Button>
              <Button
                disableElevation
                variant="contained"
                color="secondary"
                onClick={editCompetency}
                style={{ marginLeft: 10, textTransform: "none" }}
              >
                Update
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      </Box>{" "}
    </Box>
  );
}

export default TermCondition;
